// extracted by mini-css-extract-plugin
export default {"format-icon":"format-icon-b8ed","rotate-icon":"rotate-icon-1145","truncate-item":"truncate-item-8a58"};